import React, { useState, useEffect, useRef } from "react";
import { Collapse } from "antd";
import { If, Then, Else } from "react-if";
import { update } from "ramda";

import { fetchOtherStaff } from "./fetchOtherStaff";
import LoadingSpinner from "../../../../../components/loadingSpinner";
import CustomButton from "../../../../../components/customButton";

import { ErrorIcon } from "../../../../../assets/svg";
import { formatPhoneWithCountryCode } from "../../../../../utilities/helpers";
import "./styles.scss";

const { Panel } = Collapse;

const OtherTab = (props) => {
  const {
    otherPatients,
    selectedPatentId,
    otherUserClaim,
    showAddNew,
    addNewButton,
    search,
    updateOtherPatientList,
    activeTab,
  } = props;

  const loadingRef = useRef();
  const [staffData, setStaffData] = useState({
    page: 0,
    hasMoreOthers: true,
    panelData: [],
    loading: true,
    currentId: "",
    totalCount: 0,
  });

  useEffect(
    () => {
      setStaffNumber();
    },
    [search, props.otherStaffReload, activeTab]
  );

  const getOtherStaffData = async (key) => {
    setStaffData((st) => ({
      ...st,
      loading: true,
    }));
    loadingRef.current = true;
    let pageNo = parseInt(staffData.page + 1);

    if (staffData.currentId !== key || search) {
      pageNo = 1;
    }

    await fetchOtherStaff(key, pageNo, search)
      .then((response) => {
        if (response && response.rows && response.rows.length > 0) {
          const newData = [...staffData.panelData, ...response.rows];
          const updatedUserIndex = otherPatients.rows.findIndex(
            (x) => x.id === key
          );
          const updatedUser = otherPatients.rows[updatedUserIndex];
          updatedUser.patients = [
            ...(updatedUser.patients || []),
            ...response.rows,
          ];
          const updatedOtherPatientList = update(
            updatedUserIndex,
            updatedUser,
            otherPatients.rows
          );
          updateOtherPatientList({
            ...otherPatients,
            rows: updatedOtherPatientList,
          });
          setStaffData((st) => ({
            ...st,
            page: pageNo,
            totalCount: response.count,
            panelData:
              staffData.currentId !== key || search ? response.rows : newData,
            hasMoreOthers: true,
            currentId: key,
          }));
        } else {
          setStaffData((st) => ({
            ...st,
            hasMoreOthers: false,
          }));
        }
        loadingRef.current = false;
      })
      .catch((err) => {
        loadingRef.current = false;
      });

    setStaffData((st) => ({
      ...st,
      loading: false,
    }));
  };

  const setStaffNumber = async (key) => {
    setStaffData((st) => ({
      ...st,
      currentId: key,
    }));
    if (key !== undefined) {
      getOtherStaffData(key);
    }
  };

  if (otherPatients && otherPatients.rows && otherPatients.rows.length > 0) {
    return (
      <section className="other-tabs-wrapper">
        <Collapse
          accordion
          className="other-tabs-collapse"
          expandIconPosition="right"
          onChange={setStaffNumber}
          activeKey={staffData.currentId}
        >
          {otherPatients.rows.map((item, index) => {
            return (
              <Panel
                header={item && (item.name || item.username)}
                key={item.id}
              >
                <If condition={staffData.loading}>
                  <Then>
                    <LoadingSpinner
                      type="small"
                      relative
                      customClassName="without-background"
                    />
                  </Then>
                </If>

                <If condition={staffData.panelData && !staffData.loading}>
                  <Then>
                    <article className="other-staff-numbers-container">
                      {staffData.panelData &&
                        staffData.panelData.map((patient, numberIndex) => {
                          const {
                            id,
                            firstName,
                            cellPhone,
                            countryCode,
                            lastName,
                            count,
                          } = patient;

                          return (
                            <section
                              className={`other-staff-number-item ${
                                selectedPatentId === id ? "active-number" : ""
                              }`}
                              key={numberIndex}
                              onClick={(e) => otherUserClaim(patient, e)}
                            >
                              <label>
                                <If condition={firstName || lastName}>
                                  <Then>
                                    <article className="user-details-wrapper">
                                      <p className="user-name">
                                        <a
                                          title={`${firstName} ${
                                            lastName ? lastName : ""
                                          }`}
                                        >{`${firstName} ${
                                          lastName ? lastName : ""
                                        }`}</a>
                                      </p>

                                      <p className="user-number">
                                        {formatPhoneWithCountryCode(
                                          cellPhone,
                                          countryCode
                                        )}
                                      </p>
                                    </article>
                                  </Then>
                                  <Else>
                                    <article className="user-details-wrapper">
                                      <p className="user-name">
                                        {formatPhoneWithCountryCode(
                                          cellPhone,
                                          countryCode
                                        )}
                                      </p>
                                    </article>
                                  </Else>
                                </If>
                              </label>

                              <If condition={count}>
                                <Then>
                                  <div className="msg-count">{count}</div>
                                </Then>
                              </If>
                            </section>
                          );
                        })}
                    </article>
                  </Then>
                </If>

                <If
                  condition={staffData.totalCount > staffData.panelData.length}
                >
                  <Then>
                    <CustomButton
                      htmlType="submit"
                      btntype="clear"
                      title="Load More"
                      onClick={() => setStaffNumber(item.id)}
                    />
                  </Then>
                </If>
              </Panel>
            );
          })}
        </Collapse>
      </section>
    );
  } else {
    return (
      <div className="side-tabs-empty">
        <ErrorIcon />
        <p className="error-message">No record found for other patients.</p>
        {showAddNew ? addNewButton() : ""}
      </div>
    );
  }
};

export default OtherTab;
